// @flow

import { reduce } from '../../network/reduce';
import type { DynamicKey } from '../../types/dynamicKeyType';
import type { SelectConvertorMap } from '../../types/commonTypes';

export type initialStateType = {
  +dynamicKeysList: DynamicKey,
  +currenciesList: SelectConvertorMap,
}

const initialState: initialStateType = {
  dynamicKeysList: {},
  currenciesList: {},
};

export const SAVE_DYNAMIC_KEYS_LIST = 'SAVE_DYNAMIC_KEYS_LIST';
export const SAVE_CURRENCIES_LIST = 'SAVE_CURRENCIES_LIST';

const dynamicKeysReducer = reduce(initialState, {
  [SAVE_DYNAMIC_KEYS_LIST]: 'dynamicKeysList',
  [SAVE_CURRENCIES_LIST]: 'currenciesList',
});

export default dynamicKeysReducer;
